<template>
    <div id="applyDetail">
        <!-- <van-nav-bar title="申请详情" fixed placeholder left-arrow>
            <a @click="$router.back()" slot="left">
                <i class="iconfont iconfanhuianniu"></i>
            </a>
        </van-nav-bar> -->
        <!-- 详情 -->
        <div class="body">
            <!-- <div class="title">
                <i class="iconfont iconbookmark"></i> 基本信息
            </div> -->
            <van-cell title="编码" :value="applyDetail.number" />
            <van-cell title="申请类型" :value="applyTypeList[applyDetail.type-1]" />
            <van-cell title="创建类型" :value="applyDetail.createType=='2'?'自动':'手动'" />
            <van-cell title="申请状态" :value="applyStatusList[applyDetail.status-1]" />
            <van-cell title="预约时间" :value="applyDetail.appointTime" />
            <van-cell title="合约编码" :value="applyDetail.contractNumber" />
            <van-cell title="出租方式" :value="applyDetail.rentType == 1 ? '合租' : '整租'" />
            <van-cell title="租期" :value="applyDetail.contractStartDate+'到'+applyDetail.contractEndDate" />
            <van-cell title="房源地址" :value="applyDetail.rentType == 1 ? applyDetail.houseAddress + applyDetail.roomNo : applyDetail.rentType == 2 ?applyDetail.houseAddress:''" />
            <van-cell title="租客姓名" :value="applyDetail.customerName" />
            <van-cell title="租客电话">
                <template #default>
                    <a class="custom-value" :href="'tel:'+applyDetail.customerPhone">
                         <i class="iconfont iconweibiaoti-"></i></a>
                </template>
            </van-cell>
                      <van-cell title="归属公司" :value="applyDetail.companyName" />
            <van-cell title="备注" :value="applyDetail.remark" />
            <van-field v-if="applyDetail.type == 1 && applyDetail.agentType == 6 && $route.query.type == 2" readonly clickable name="sotreId" :value="storeText" label="门店" placeholder="点击选择>" :right-icon="storeText?'close':''" @click-right-icon.stop="form.storeId = '';ownerList=[];storeText = '';form.receiptId='';receiptText=''" @click="showStore = true" :rules="[{ required: true, message: '请选择门店' }]" />
            <van-field v-if="applyDetail.type == 1 && applyDetail.agentType == 6 && $route.query.type == 2" readonly clickable name="receiptId" :value="receiptText" label="管家" placeholder="点击选择>" :right-icon="receiptText?'close':''" @click-right-icon.stop="form.receiptId='';receiptText=''" @click="showReceipt = true" :rules="[{ required: true, message: '请选择管家' }]" />
        </div>
        <div v-if="$route.query.type == 2&&applyDetail.showBtn" style="height:1.2rem;"></div>
        <div class="btn" v-if="$route.query.type == 2">
            <van-button v-if="applyDetail.showBtn" class="font2" type="primary" :loading="saveLoad" :disabled="saveLoad" @click="save">操作</van-button>
            <van-button class="font5" type="primary" :loading="lookLoadOld" :disabled="lookLoadOld" @click="lookDetailOld">旧合约<br>{{applyDetail.contractNumber}}</van-button>
            <van-button v-if="applyDetail.showLook" class="font5" type="primary" :loading="lookLoad" :disabled="lookLoad" @click="lookDetail">新合约<br>{{applyDetail.nextContractNumber}}</van-button>
        </div>
        <!-- 门店 -->
        <van-popup v-model="showStore" position="bottom">
            <van-picker show-toolbar :columns="storeList" value-key="name" @confirm="item => { storeText=item.name;form.storeId = item.id;showStore=false;changeStore() }" @cancel="showStore = false" />
        </van-popup>
        <!-- 管家 -->
        <van-popup v-model="showReceipt" position="bottom">
            <van-picker show-toolbar :columns="ownerList" value-key="name" @confirm="item => { receiptText=item.name;form.receiptId = item.id;showReceipt=false }" @cancel="showReceipt = false" />
        </van-popup>
    </div>
</template>

<script>
import { mapState } from "vuex";
import {
    requestApplyDetail,
    requestNowStore,
    requestCompanyOwner,
    requestApplyTransfer,
    requestAgentDetail,
    requestContractSubmit,
    requestReturnSubmit,
    requestSubmitValid
} from "@/api";

export default {
    name: "applyDetail",
    data() {
        return {
            applyDetail: {
                numer: "",
                type: "",
                status: "",
                appointTime: "",
                contractNumber: "",
                rentType: "",
                contractStartDate: "",
                contractEndDate: "",
                houseAddress: "",
                roomNo: "",
                customerName: "",
                customerPhone: "",
                remark: ""
            },
            showStore: false,
            showReceipt: false,
            storeText: "",
            receiptText: "",
            storeList: [],
            ownerList: [],
            form: {
                storeId: "", //门店id
                receiptId: "", //管家id
                agentId: "", //待办id
                applyId: "" //申请id
            },
            saveLoad: false,
            lookLoad: false,
            lookLoadOld: false
        };
    },
    computed: {
        ...mapState([
            "idTypeList",
            "destineList",
            "payList",
            "contractList",
            "customerList",
            "cancelStatusList",
            "approvalStatusList",
            "applyTypeList",
            "applyStatusList"
        ])
    },
    created() {},
    mounted() {
        this.getDetail();
        this.getStore();
    },
    methods: {
        getDetail() {
            const toast1 = this.$toast.loading({
                forbidClick: true,
                duration: 0,
                message: "加载中..."
            });
            requestApplyDetail(this.$route.query.id)
                .then(res => {
                    res.data.agentType = this.$route.query.agentType / 1;
                    res.data.agentId = this.$route.query.agentId;
                    //判断操作按钮
                    switch (res.data.agentType) {
                        case 6:
                            //换房
                            requestAgentDetail(res.data.agentId)
                                .then(res1 => {
                                    // if (this.$route.query.source == "dingTalk") {
                                    //     res.data.showBtn = !(
                                    //         (res.data.nextContractId == null &&
                                    //             res.data.returnOrderId == null &&
                                    //             res1.data.processStatus == 1) ||
                                    //         res.data.nextContractId != null ||
                                    //         res.data.returnOrderId != null
                                    //     );
                                    // } else {
                                    //     res.data.showBtn =
                                    //         (!res.data.nextContractId &&
                                    //             !res.data.returnOrderId) ||
                                    //         (res.data.nextContractId &&
                                    //             res.data.nextContractStatus == 1) ||
                                    //         (res.data.returnOrderId &&
                                    //             res.data.returnOrderStatus == 1 &&
                                    //             res1.data.processStatus == 2);
                                    // }
                                    res.data.showBtn =
                                        (!res.data.nextContractId &&
                                            !res.data.returnOrderId) ||
                                        (res.data.nextContractId &&
                                            res.data.nextContractStatus == 1) ||
                                        (res.data.returnOrderId &&
                                            res.data.returnOrderStatus == 1 &&
                                            res1.data.processStatus == 2);
                                    this.applyDetail = res.data;
                                    this.loading = false;
                                    toast1.clear();
                                })
                                .catch(err => {
                                    toast1.clear();
                                });
                            break;
                        case 7:
                        //转租（老合约生成退租单）
                        case 8:
                            //续约
                            res.data.showBtn =
                                (!res.data.nextContractId &&
                                    !res.data.returnOrderId) ||
                                (res.data.nextContractId &&
                                    res.data.nextContractStatus == 1);
                            this.applyDetail = res.data;
                            this.loading = false;
                            toast1.clear();
                            break;
                        case 10:
                            //换房退租
                            // if (this.$route.query.source == "dingTalk") {
                            //     res.data.showBtn = res.data.returnOrderStatus == 1;
                            // } else {
                            //     res.data.showBtn =
                            //         (!res.data.nextContractId &&
                            //             !res.data.returnOrderId) ||
                            //         (res.data.nextContractId &&
                            //             res.data.nextContractStatus == 1) ||
                            //         (res.data.returnOrderId &&
                            //             res.data.returnOrderStatus == 1);
                            // }
                            res.data.showBtn =
                                (!res.data.nextContractId &&
                                    !res.data.returnOrderId) ||
                                (res.data.nextContractId &&
                                    res.data.nextContractStatus == 1) ||
                                (res.data.returnOrderId &&
                                    res.data.returnOrderStatus == 1);
                            this.applyDetail = res.data;
                            this.loading = false;
                            toast1.clear();
                            break;
                        default:
                            //非换房
                            // if (this.$route.query.source == "dingTalk") {
                            //     res.data.showBtn = !(
                            //         res.data.nextContractId != null ||
                            //         res.data.returnOrderId != null
                            //     );
                            // } else {
                            //     res.data.showBtn =
                            //         (!res.data.nextContractId &&
                            //             !res.data.returnOrderId) ||
                            //         (res.data.nextContractId &&
                            //             res.data.nextContractStatus == 1) ||
                            //         (res.data.returnOrderId &&
                            //             res.data.returnOrderStatus == 1);
                            // }
                            res.data.showBtn =
                                (!res.data.nextContractId &&
                                    !res.data.returnOrderId) ||
                                (res.data.nextContractId &&
                                    res.data.nextContractStatus == 1) ||
                                (res.data.returnOrderId &&
                                    res.data.returnOrderStatus == 1);
                            this.applyDetail = res.data;
                            this.loading = false;
                            toast1.clear();
                            break;
                    }
                    if (
                        (res.data.agentType == 6 ||
                            res.data.agentType == 7 ||
                            res.data.agentType == 8) &&
                        res.data.nextContractNumber
                    ) {
                        res.data.showLook = true;
                    }
                    // //判断详情（新合约）按钮
                    // if (
                    //     (res.data.agentType == 6 ||
                    //         res.data.agentType == 7 ||
                    //         res.data.agentType == 8) &&
                    //     res.data.nextContractId &&
                    //     res.data.nextContractStatus == 1
                    // ) {
                    //     //换转续&&存在合约&&合约是保存状态
                    //     res.data.showLook = true;
                    // }
                    // if (
                    //     (res.data.agentType == 9 || res.data.agentType == 10) &&
                    //     res.data.returnOrderId &&
                    //     res.data.returnOrderStatus == 1
                    // ) {
                    //     //退租&&存在退租单&&退租单状态是保存
                    //     res.data.showLook = true;
                    // }
                    console.log(res);
                })
                .catch(err => {
                    toast1.clear();
                });
        },
        getStore() {
            requestNowStore().then(res => {
                this.storeList = res.data || [];
            });
        },
        changeStore() {
            this.form.receiptId = "";
            this.receiptText = "";
            this.ownerList = [];
            //根据门店查管家
            requestCompanyOwner({
                companyId: "",
                storeId: this.form.storeId
            })
                .then(res => {
                    this.ownerList = res.data || [];
                })
                .catch(err => {});
        },
        //操作
        save() {
            this.form.agentId = this.applyDetail.agentId;
            this.form.applyId = this.applyDetail.id;
            const type = this.applyDetail.type;
            if (this.form.storeId && type == 1 && !this.form.receiptId) {
                // this.$toast.fail("请选择管家");
                this.$dialog.alert({ message: "请选择管家" });
                return;
            }
            switch (type) {
                case 1:
                    //换房
                    if (this.applyDetail.agentType == 6) {
                        //换房申请
                        if (this.form.receiptId) {
                            this.saveLoad = true;
                            requestApplyTransfer(this.form).then(res => {
                                this.$toast.success({
                                    message: "操作成功！",
                                    // forbidClick: true,
                                    onClose: () => {}
                                });
                                this.$router.back();
                                this.saveLoad = false;
                                this.getDetail();
                            });
                        } else {
                            if (this.applyDetail.nextContractId) {
                                //有保存状态
                                this.$router.push({
                                    path: "contractAdd",
                                    query: {
                                        contractId: this.applyDetail
                                            .nextContractId
                                    }
                                });
                            } else {
                                this.$router.push({
                                    path: "contractAdd",
                                    query: {
                                        changeHouseContractId: this.applyDetail
                                            .contractId
                                    }
                                });
                            }
                        }
                    } else {
                        //换房退租申请
                        if (this.applyDetail.returnOrderId) {
                            //有保存状态
                            this.$router.push({
                                path: "returnOrderAdd",
                                query: {
                                    id: this.applyDetail.returnOrderId
                                }
                            });
                        } else {
                            this.$router.push({
                                path: "returnOrderAdd",
                                query: {
                                    contractId: this.applyDetail.contractId
                                }
                            });
                        }
                    }
                    break;
                case 2:
                    //转租申请
                    if (this.applyDetail.nextContractId) {
                        //有保存状态
                        this.$router.push({
                            path: "contractAdd",
                            query: {
                                contractId: this.applyDetail.nextContractId
                            }
                        });
                    } else {
                        this.$router.push({
                            path: "contractAdd",
                            query: {
                                transferContractId: this.applyDetail.contractId
                            }
                        });
                    }
                    break;
                case 3:
                    //续约申请
                    if (this.applyDetail.nextContractId) {
                        //有保存状态
                        this.$router.push({
                            path: "contractAdd",
                            query: {
                                contractId: this.applyDetail.nextContractId
                            }
                        });
                    } else {
                        this.$router.push({
                            path: "contractAdd",
                            query: {
                                prevContractId: this.applyDetail.contractId
                            }
                        });
                    }
                    break;
                case 4:
                    //退租申请
                    if (this.applyDetail.returnOrderId) {
                        //有保存状态
                        this.$router.push({
                            path: "returnOrderAdd",
                            query: {
                                id: this.applyDetail.returnOrderId
                            }
                        });
                    } else {
                        this.$router.push({
                            path: "returnOrderAdd",
                            query: {
                                contractId: this.applyDetail.contractId
                            }
                        });
                    }
                    break;
                default:
                    break;
            }
        },
        //查看(新合约)
        lookDetail() {
            //合约
            if (
                this.applyDetail.agentType == 6 ||
                this.applyDetail.agentType == 7 ||
                this.applyDetail.agentType == 8
            ) {
                this.$router.push({
                    path: "contractDetail",
                    query: {
                        id: this.applyDetail.nextContractId
                    }
                });
            }
            // //退租单
            // if (
            //     this.applyDetail.agentType == 9 ||
            //     this.applyDetail.agentType == 10
            // ) {
            //     this.$router.push({
            //         path: "returnOrderDetail",
            //         query: {
            //             id: this.applyDetail.nextContractId
            //         }
            //     });
            // }
        },
        //查看（老合约）
        lookDetailOld() {
            this.$router.push({
                path: "contractDetail",
                query: {
                    id: this.applyDetail.contractId
                }
            });
        }
    },
    watch: {}
};
</script>
<style lang="scss" scoped>
@import "../common/scss/variable.scss";

.body {
    .title {
        text-align: left;
        padding: 0.3rem 0.2rem;
        font-weight: 600;
        font-size: 0.37rem;
    }
}

.theme-color {
    color: $theme-color;
}

.btn {
    width: 100%;
    position: fixed;
    bottom: 0;
    left: 0;
    border-radius: 0.1rem;
    overflow: hidden;
    display: flex;

    /deep/ .van-button {
        margin-left: -1px;
        border: none;
        border-radius: 0;
        flex: 1;

        &:not(:last-child)::after {
            height: 50%;
            position: absolute;
            box-sizing: border-box;
            content: " ";
            pointer-events: none;
            right: 0;
            top: 50%;
            transform: translateY(-50%);
            border-right: 0.02667rem solid #ebedf0;
            z-index: 99;
        }
    }

    .font4 {
        width: 2.9rem;
    }

    .font3 {
        width: 2.5rem;
    }

    .font2 {
        width: 2.1rem;
    }
    .font5 {
        width: 3.7rem;
    }
}

.van-field {
    /deep/ .van-field__body {
        input {
            text-align: right;
        }
    }
}

.van-steps {
    text-align: left;
    padding-left: 2rem;

    /deep/ .van-step__title {
        padding-left: 0.3rem;

        p {
            padding-top: 0.2rem;
        }
    }
}

/deep/ .van-field__error-message {
    text-align: right;
}

/deep/ a {
    color: $theme-color;
    i {
        color: $theme-color;
    }
}
</style>
